export class User {
    name: string;
    first_name: string;
    last_name: string;
    email: string;
    id?: string;
    is_rxspeed?: boolean;
}
